import styled from 'styled-components';

interface IProps {
	isHovered?: boolean;
	direction: 'north' | 'east' | 'south' | 'west';
}

const TooltipDark = styled.div<IProps>`
	position: absolute;
	background-color: ${(props) => props.theme.colors.antracite};
	left: ${(props) =>
		props.direction === 'west' ? '0%' : props.direction === 'east' ? '100%' : '50%'};
	top: ${(props) =>
		props.direction === 'north' ? '0%' : props.direction === 'south' ? '100%' : '50%'};
	transform: translateX(
			${(props) =>
				props.direction === 'west' ? '-100%' : props.direction === 'east' ? '0%' : '-50%'}
		)
		translateY(
			${(props) =>
				props.direction === 'north' ? '-100%' : props.direction === 'south' ? '7px' : '-50%'}
		);
	font-size: 14px;
	font-weight: 500;
	color: ${(props) => props.theme.colors.white};
	white-space: nowrap;
	padding: 4px 6px 2px 6px;
	border-radius: 3px;
	box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%);
	pointer-events: none;
	user-select: none;
	opacity: 0;
	transition: 150ms opacity ease-out;
	z-index: 100;

	${(props) => (props.isHovered ? 'opacity: 1;' : '')}

	// Arrow of the tooltip
	&:after {
		content: '';
		position: absolute;

		left: ${(props) =>
			props.direction === 'east' ? '0%' : props.direction === 'west' ? '100%' : '50%'};
		top: ${(props) =>
			props.direction === 'south' ? '0%' : props.direction === 'north' ? '100%' : '50%'};

		transform: translateX(
				${(props) =>
					props.direction === 'east' ? '-100%' : props.direction === 'west' ? '0%' : '-50%'}
			)
			translateY(
				${(props) =>
					props.direction === 'south' ? '-100%' : props.direction === 'north' ? '0%' : '-50%'}
			);

		z-index: 8;
		border: 5px solid transparent;
		border-left-color: ${(props) =>
			props.direction === 'west' ? props.theme.colors.antracite : 'transparent'};
		border-right-color: ${(props) =>
			props.direction === 'east' ? props.theme.colors.antracite : 'transparent'};
		border-top-color: ${(props) =>
			props.direction === 'north' ? props.theme.colors.antracite : 'transparent'};
		border-bottom-color: ${(props) =>
			props.direction === 'south' ? props.theme.colors.antracite : 'transparent'};
		display: block;
	}
`;

export default TooltipDark;
